import React from "react";
import "./VideoGallery.css";

const videos = [
  {
    id: 1,
    title: "Laser Show",
    src: "./images/laser_show.mp4",
    poster: "./images/spst-l1.jpeg"
  },
//   {
//     id: 2,
//     title: "Event Highlights",
//     src: "/videos/video2.mp4",
//     poster: "/images/thumb2.jpg"
//   },
//   {
//     id: 3,
//     title: "Product Demo",
//     src: "/videos/video3.mp4",
//     poster: "/images/thumb3.jpg"
//   }
];

const VideoGallery = () => {
  return (
    <div className="video-wrapper">
      {videos.map((video) => (
        <div className="video-card" key={video.id}>
          <video
            controls
            preload="metadata"
            poster={video.poster}
          >
            <source src={video.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h4>{video.title}</h4>
        </div>
      ))}
    </div>
  );
};

export default VideoGallery;
